import { render, staticRenderFns } from "./HangRecord.vue?vue&type=template&id=736a5a4d&scoped=true"
import script from "./HangRecord.vue?vue&type=script&lang=js"
export * from "./HangRecord.vue?vue&type=script&lang=js"
import style0 from "./HangRecord.vue?vue&type=style&index=0&id=736a5a4d&prod&lang=scss&scoped=true"
import style1 from "./HangRecord.vue?vue&type=style&index=1&id=736a5a4d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736a5a4d",
  null
  
)

export default component.exports